import { render, staticRenderFns } from "./DtDetailFour.vue?vue&type=template&id=730fbd12&scoped=true"
import script from "./DtDetailFour.vue?vue&type=script&lang=js"
export * from "./DtDetailFour.vue?vue&type=script&lang=js"
import style0 from "./DtDetailFour.vue?vue&type=style&index=0&id=730fbd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730fbd12",
  null
  
)

export default component.exports